(() => {
  if (customElements.get('ax-sleep-setup')) return;
  let timer, request, revision = 0;
  function scheduleRefresh() {
    const version = ++revision;
    clearTimeout(timer);
    request?.abort();
    timer = setTimeout(async () => {
      const first = document.querySelector('ax-sleep-setup');
      if (!first) return;
      request = new AbortController();
      try {
        const response = await fetch(first.dataset.cartUrl, { cache: 'no-store', signal: request.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (version !== revision || !Array.isArray(cart.items)) return;
        document.querySelectorAll('ax-sleep-setup').forEach(setup => setup.update(cart.items));
        document.querySelectorAll('.axpp-pair').forEach(row => {
          const button = row.querySelector('.axpp-pair__add');
          if (!button || button.dataset.adding) return;
          const packed = cart.items.some(item => String(item.variant_id) === row.dataset.pairId && item.quantity > 0);
          button.disabled = packed;
          button.textContent = packed ? row.dataset.bag : row.dataset.addLabel;
          button.setAttribute('aria-label', packed ? row.dataset.addedLabel : row.dataset.addAria);
          button.toggleAttribute('data-packed', packed);
        });
      } catch (error) {}
    }, 70);
  }
  class SleepSetup extends HTMLElement {
    connectedCallback() { scheduleRefresh(); }
    update(items) {
      const included = {};
      for (const kind of ['mask', 'earplugs']) {
        const handles = (this.dataset[kind === 'mask' ? 'maskHandles' : 'earplugHandles'] || '').split(',');
        included[kind] = this.dataset.selectedKind === kind || items.some(item => item.quantity > 0 && handles.includes(item.handle));
        const step = this.querySelector(`[data-setup-step="${kind}"]`);
        const fill = this.querySelector(`[data-setup-fill="${kind}"]`);
        step.dataset.included = fill.dataset.included = String(included[kind]);
        step.querySelector('.ax-setup__check').textContent = included[kind] ? '✓' : '○';
        step.querySelector('[data-setup-included]').hidden = !included[kind];
        step.querySelector('[data-setup-missing]').hidden = included[kind];
        const link = this.querySelector(`[data-setup-link="${kind}"]`);
        if (link) link.hidden = included[kind];
      }
      const count = Number(included.mask) + Number(included.earplugs);
      this.hidden = count === 0;
      this.querySelector('[data-setup-count]').textContent = count === 2 ? this.dataset.countTwo : this.dataset.countOne;
      const message = count === 2 ? this.dataset.complete : this.dataset.incomplete;
      const status = this.querySelector('[data-setup-message]');
      if (status.textContent !== message) status.textContent = message;
    }
  }
  customElements.define('ax-sleep-setup', SleepSetup);
  document.addEventListener('cart:update', event => { if (!event.detail?.data?.didError) scheduleRefresh(); });
  window.addEventListener('pageshow', scheduleRefresh);
})();
